module.exports = __webpack_public_path__ + "static/media/successOnboard.88a1afb9.svg";